import { Button, Form, Input, Modal, Select } from "antd";
import React from "react";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const usaStates = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

const VipModal = ({ open, setOpen, state }) => {
  const [form] = Form.useForm();
  const onFinish = (values) => {
    Swal.fire({
      title: "Submit Successfully!",
      // text: "You clicked the button!",
      icon: "success",
    });
    onCancel();
  };

  const onCancel = () => {
    form.resetFields();
    setOpen(false);
  };

  return (
    <Modal
      title={<h2 style={{ textAlign: "center" }}>VIP ACCESS</h2>}
      onCancel={onCancel}
      open={open}
      footer={null}
    >
      <div style={{ textAlign: "center", width: "100%" }}>
        Join to unlock exclusive access to retail-ready, wholesale home
        entertainment products
      </div>
      <hr style={{ margin: "10px 0px 5px 0px" }} />
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: "Required!" }]}
        >
          <Input placeholder="Name" />
        </Form.Item>
        <Form.Item
          name="business"
          label="Business Name"
          rules={[{ required: true, message: "Required!" }]}
        >
          <Input placeholder="Business Name" />
        </Form.Item>
        <Form.Item
          name={"streetAddress"}
          label="Street Address"
          rules={[{ required: true, message: "required!" }]}
        >
          <Input placeholder="Street Address" />
        </Form.Item>
        <Form.Item
          name="city"
          label="City"
          rules={[{ required: true, message: "required!" }]}
        >
          <Input placeholder="City" />
        </Form.Item>
        <Form.Item
          name="state"
          label="State"
          rules={[{ required: true, message: "required!" }]}
        >
          <Select
            showSearch
            style={{ width: "100%", height: 43 }}
            placeholder="Select a state"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
          >
            {usaStates.map((state) => (
              <Select.Option key={state} value={state}>
                {state}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name={"zipcode"}
          label="Zip Code"
          rules={[{ required: true, message: "required!" }]}
        >
          <Input placeholder="Zip code" />
        </Form.Item>
        <Form.Item
          name="website"
          label="Website"
          rules={[{ required: true, message: "Required!" }]}
        >
          <Input placeholder="Website" />
        </Form.Item>
        <Form.Item
          name="experience"
          label="Number of Years in Business"
          rules={[{ required: true, message: "Required!" }]}
        >
          <Input defaultValue={0} type="number" />
        </Form.Item>
        <div style={{ textAlign: "end" }}>
          <Button
            htmlType="submit"
            style={{ border: "1px solid #2ca3dd", color: "#2ca3dd" }}
          >
            Submit for Approval
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default VipModal;
